module.exports = __webpack_public_path__ + "static/media/mc_remove_tube_icon.34e6b231.svg";